// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__FfT1n","header":"Header_header__hwyZT","link":"Header_link__o2ZlE"};